export const ANALYTICS_NOT_AVAILABLE = 'Analytics is not available';
export const ANALYTICS_NOT_INITIALIZED = 'Analytics is not initialized';
export const META_PIXEL_NOT_AVAILABLE = 'Meta Pixel is not available';
